export const discountProductPrice = (price) => {
    return +(price * 0.8).toFixed(2);
}